import setCssVariable from "@/helpers/setCssVariable";
import cssVariables from "@/config/cssVariables";

// Set each defined variable in css variable
Object.entries(cssVariables)
  .forEach(([name, value]) => {
    setCssVariable(`--${ name }`, value)
  })